<template>
  <div class="info-window">
    <div class="row">
      <div v-for="(item, key) in products" :key="key" :class="[`col-12 col-md-${12 / products.length}`]">
        <h4>{{ replaceName(item.product.product_name) }}</h4>
        <h5 class="my-3 text-center">{{currency}}{{item.product.price}}</h5>
        <div>
          <button v-if="book == true" type="button" :class="{'full': more }" @click="select(item.product)" class="btn btn-xs btn-secondary block"> 
            {{ bookNowText }}
          </button>
          <button  v-if="more != true" type="button" @click="info(item.product)" class="btn btn-xs btn-secondary block">
            {{ moreInfoText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import { eventBus } from "@/eventBus";

export default {
  name: "mapMarker",
  props: {
    product: { type: Object },
    products: { type: Array, default: () => [] },
    bookNowText: { type: String },
    moreInfoText: { type: String },
    more: { default: false, type: Boolean },
    book: { default: true, type: Boolean },
    currency: { default: '£', type: String },
    airport: { default: '', type: String }
  },
  computed: {
    moreInfo: sync("modals/moreInfo"),
  },
  methods: {
    select(item) {
      eventBus.$emit('SELECTED', item)
    },
    replaceName(value) {
      return value.replace(this.airport, '').replace('Airport -', '')
    },
    info(item) {
      eventBus.$emit('MORE_INFO', item)
    }
  }
};
</script>